import { addDoc, collection, serverTimestamp } from "firebase/firestore";
import { db } from "../config/FirebaseConfig"; // db exported from your config

class ContactUsApi {
    // '<' operator is used to filter based on less than
    // '<=' operator is used to filter based on less than or equal to
    // '==' operator is used to filter based on equal to
    // '>' operator is used to filter based on greater than
    // '>=' operator is used to filter based on greater than or equal to
    // '!=' operator is used to filter based on not equal to
    // 'array-contains' operator is used to filter based on array contains
    // 'array-contains-any' operator is used to filter based on array contains any
    // 'in' operator is used to filter based on in
    // 'not-in' operator is used to filter based on not in

    /*{
        name: string,
        email: string,
        subject: string,
        message: string,
        uid: string | null, // Optional, if the user is logged in
        createdAt: timestamp,
        updatedAt: timestamp
    }*/

    async createContactUs(body = {}) {
        if (!body || !body.name || !body.email || !body.subject || !body.message) {
            console.error("Invalid contact us data:", body);
            return { success: false, error: "Invalid contact us data" };
        }
        try {
            await addDoc(collection(db, "contactus"), {
                name: body.name,
                email: body.email,
                subject: body.subject,
                message: body.message,
                uid: body.uid || null,
                createdAt: serverTimestamp(),
                updatedAt: serverTimestamp(),
            });
            return { success: true };
        } catch (error) {
            console.error("Error creating contact us entry:", error);
            return { success: false, error: error.message };
        }
    }

}

export default ContactUsApi;